$(function() {
  const ref = document.referrer;
  const isFromFacebook = ref.includes('facebook.com');
  const isFromInstagram = ref.includes('instagram.com');

  // 流入元チェック（FBかInstagramのみ）
  if ((isFromFacebook || isFromInstagram)) {
    // 表示処理（複数回でも出したいためcookieチェックはオフ）
    $(".popup_overlay").css({ display: 'block', opacity: '0' }).delay(500).animate({ opacity: '1' }, 500);
    $(".popup_overlay .popup").delay(1000).animate({ opacity: '1' }, 500);

    // 閉じたときに一時的に非表示（cookie制御ONにしていない）
    $(".popupInfo a, .close_popup").click(function() {
      $(".popup_overlay").fadeOut();
    });
  }
});
